import * as React from "react";
const SvgChevronRight = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M12.5 12 8 7.5l2-2 6.5 6.5-6.5 6.5-2-2z" })));
export default SvgChevronRight;
//# sourceMappingURL=ChevronRight.js.map